import { render, staticRenderFns } from "./OwnerQuery.vue?vue&type=template&id=42d1d66d&scoped=true"
import script from "./OwnerQuery.vue?vue&type=script&lang=js"
export * from "./OwnerQuery.vue?vue&type=script&lang=js"
import style0 from "./OwnerQuery.vue?vue&type=style&index=0&id=42d1d66d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1d66d",
  null
  
)

export default component.exports